import React from 'react'
import { Tooltip } from 'antd'

import { RequestTicketUserData } from 'src/types'
import UserAvatar from 'src/components/UserAvatar'

import { WrapAvatar } from './style'

function AvatarListHorizontal({
  ownerInfo,
  users
}: {
  ownerInfo?: any
  users: RequestTicketUserData[]
}) {
  if (!users?.length) {
    return <></>
  }
  return (
    <>
      {users.map((user, index) => (
        <Tooltip
          key={index}
          title={
            <>
              <span>
                {user.owner && !!ownerInfo ? (
                  <>
                    {ownerInfo}
                    <br />
                  </>
                ) : (
                  ''
                )}
              </span>
              <span>{user.traveler.name}</span>
            </>
          }
        >
          <WrapAvatar>
            <UserAvatar
              gender={user.traveler.gender}
              name={`${user.traveler.name}`}
              size="large"
            />
          </WrapAvatar>
        </Tooltip>
      ))}
    </>
  )
}

export default AvatarListHorizontal
